import { NgModule } from '@angular/core';
import { StartWithStringPipe } from '@shared/pipes/startWithString/startWithString.pipe';

@NgModule({
  declarations: [StartWithStringPipe],
  exports: [StartWithStringPipe],
})
export class StartWithStringPipeModule {}
